import { ButtonProps } from '../../atoms/Button';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';
import { DropzoneProps } from '../Dropzone';

type DropzoneInternalProps = {
  icon?: IconProps;
  text?: TextProps;
  dropzone?: DropzoneProps;
  icon1?: IconProps;
  instructions?: TextProps;
  oR?: TextProps;
  button?: ButtonProps;
};

type DropzonePropsValues = {
  'DefaultError': DropzoneInternalProps;
  'DefaultNone': DropzoneInternalProps;
  'DraggingError': DropzoneInternalProps;
  'DraggingNone': DropzoneInternalProps;
  'LoadingNone': DropzoneInternalProps;
};

const propValues: DropzonePropsValues = {
  'DefaultError': {
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    icon1: {
      asset: 'UploadCircle',
      colour: 'IconPrimary',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    oR: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'DefaultNone': {
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    icon1: {
      asset: 'UploadCircle',
      colour: 'IconPrimary',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    oR: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'DraggingError': {
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    icon1: {
      asset: 'UploadCircle',
      colour: 'IconPrimary',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    oR: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'DraggingNone': {
    icon: {
      asset: 'Error',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    icon1: {
      asset: 'UploadCircle',
      colour: 'IconPrimary',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body1',
    },
    oR: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading3',
    },
    button: {
      type: 'Text',
      size: 'M',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'LoadingNone': {
    icon: {
      asset: 'Loading',
      colour: 'IconPrimary',
    },
  },
};

const getProps = (type: string): DropzoneInternalProps => {
  const values: DropzoneInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
